"use client";

import { FormEvent, useState } from "react";

export default function ContactForm() {
  const [sending, setSending] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState("");

  async function handleSubmit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();

    setSending(true);
    setSuccess(false);
    setError("");

    const form = event.currentTarget;
    const formData = new FormData(form);

    const data = {
      name: formData.get("name"),
      phone: formData.get("phone"),
      email: formData.get("email"),
      message: formData.get("message"),
      website: formData.get("website"),
    };

    try {
      const response = await fetch("/api/contact", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });

      const result = await response.json();

      if (!response.ok) {
        throw new Error(result.error || "Une erreur est survenue.");
      }

      setSuccess(true);
      form.reset();
    } catch (err) {
      setError(
        err instanceof Error
          ? err.message
          : "Impossible d'envoyer votre demande."
      );
    } finally {
      setSending(false);
    }
  }

  return (
    <form onSubmit={handleSubmit} className="w-full max-w-xl">
      <div
        className="absolute -left-[9999px] h-px w-px overflow-hidden"
        aria-hidden="true"
      >
        <label htmlFor="website">Ne pas remplir ce champ</label>
        <input
          id="website"
          name="website"
          type="text"
          tabIndex={-1}
          autoComplete="off"
        />
      </div>

      <div className="space-y-7">
        <div>
          <label
            htmlFor="name"
            className="text-xs font-semibold uppercase tracking-[0.2em] text-[#52634f]"
          >
            Nom *
          </label>

          <input
            id="name"
            name="name"
            type="text"
            required
            autoComplete="name"
            className="mt-3 w-full rounded-xl border border-[#52634f]/20 bg-white/35 px-4 py-3.5 text-base text-[#182019] outline-none transition placeholder:text-[#526057]/45 focus:border-[#52634f] focus:bg-white/55"
            placeholder="Votre nom"
          />
        </div>

        <div>
          <label
            htmlFor="phone"
            className="text-xs font-semibold uppercase tracking-[0.2em] text-[#52634f]"
          >
            Téléphone
          </label>

          <input
            id="phone"
            name="phone"
            type="tel"
            autoComplete="tel"
            className="mt-3 w-full rounded-xl border border-[#52634f]/20 bg-white/35 px-4 py-3.5 text-base text-[#182019] outline-none transition placeholder:text-[#526057]/45 focus:border-[#52634f] focus:bg-white/55"
            placeholder="06 00 00 00 00"
          />
        </div>

        <div>
          <label
            htmlFor="email"
            className="text-xs font-semibold uppercase tracking-[0.2em] text-[#52634f]"
          >
            E-mail *
          </label>

          <input
            id="email"
            name="email"
            type="email"
            required
            autoComplete="email"
            className="mt-3 w-full rounded-xl border border-[#52634f]/20 bg-white/35 px-4 py-3.5 text-base text-[#182019] outline-none transition placeholder:text-[#526057]/45 focus:border-[#52634f] focus:bg-white/55"
            placeholder="votre@email.fr"
          />
        </div>

        <div>
          <label
            htmlFor="message"
            className="text-xs font-semibold uppercase tracking-[0.2em] text-[#52634f]"
          >
            Votre projet *
          </label>

          <textarea
            id="message"
            name="message"
            required
            rows={6}
            className="mt-3 w-full resize-none rounded-xl border border-[#52634f]/20 bg-white/35 px-4 py-3.5 text-base text-[#182019] outline-none transition placeholder:text-[#526057]/45 focus:border-[#52634f] focus:bg-white/55"
            placeholder="Décrivez-nous votre projet, vos envies et, si possible, la nature de votre extérieur..."
          />
        </div>

        {error && (
          <div className="rounded-xl border border-red-900/10 bg-red-950/5 p-4 text-sm leading-6 text-red-900">
            {error}
          </div>
        )}

        {success && (
          <div className="rounded-xl border border-[#52634f]/20 bg-[#52634f]/10 p-4 text-sm leading-6 text-[#304635]">
            <p className="font-semibold">
              Votre demande a bien été envoyée.
            </p>
            <p className="mt-1">
              Nous reviendrons vers vous rapidement.
            </p>
          </div>
        )}

        <div className="pt-1">
          <button
            type="submit"
            disabled={sending}
            className="inline-flex items-center rounded-full bg-[#182019] px-7 py-4 text-sm font-semibold text-white transition hover:bg-[#304635] disabled:cursor-not-allowed disabled:opacity-60"
          >
            {sending ? "Envoi en cours..." : "Envoyer ma demande"}
            {!sending && <span className="ml-3 text-lg">↗</span>}
          </button>

          <p className="mt-4 text-xs leading-5 text-[#526057]/75">
            Les informations transmises servent uniquement à répondre à votre
            demande.
          </p>
        </div>
      </div>
    </form>
  );
}
